export default "__VITE_ASSET__BpWGhKte__"